import { Star } from "./Star";
import { useI18n } from "@/context/LanguageContext";

export const Footer = () => {
  const { t } = useI18n();
  return (
    <footer data-testid="site-footer" className="bg-white py-12 border-t-2 border-[#141518]">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3 font-condensed uppercase tracking-[0.25em] text-[10px]">
          <Star size={12} className="text-[#F0311B]" />
          {t.footer.tagline}
          <Star size={12} className="text-[#F0311B]" />
        </div>
        <div className="font-display font-bold italic text-2xl text-[#141518]">
          Ariadna <span className="text-[#F0311B]">&amp;</span> Wojtek
        </div>
        <div className="font-condensed uppercase tracking-[0.25em] text-[10px] text-[#5A5A5F]">
          {t.footer.place}
        </div>
      </div>
    </footer>
  );
};
